<app-mobile-page-shell [hideBottomNav]="true">

  <!-- ===================== DETAILS TAB ===================== -->
  <div *ngIf="activeTab === 'details'" class="form-stack">

    <app-section-card variant="primary" icon="bi-building" title="Primary Business Information">
      <div class="m-field">
        <label>Business Name</label>
        <input class="form-control m-form-control"
          [ngModel]="businessName"
          (ngModelChange)="businessNameChange.emit($event)"
          placeholder="Enter business name" />
      </div>
      <div class="m-field">
        <label>Business Physical Address</label>
        <input class="form-control m-form-control"
          [ngModel]="location"
          (ngModelChange)="locationChange.emit($event)"
          placeholder="Enter location" />
      </div>
      <div class="m-field">
        <label>Business Brief Description</label>
        <textarea class="form-control m-form-control" rows="3"
          [ngModel]="businessBrief"
          (ngModelChange)="businessBriefChange.emit($event)"
          placeholder="Brief description"></textarea>
      </div>
    </app-section-card>

    <app-section-card variant="classification" icon="bi-diagram-3" title="Business Classification">
      <div class="m-field">
        <label>Industry Sector</label>
        <app-single-select-dropdown
          [options]="industries"
          [selectedValue]="industry ?? ''"
          (selectedValueChange)="industryChange.emit($event)">
        </app-single-select-dropdown>
      </div>
      <div class="m-field">
        <label>Business Type</label>
        <app-single-select-dropdown
          [options]="filteredBusinessTypes"
          [selectedValue]="businessType ?? ''"
          (selectedValueChange)="businessTypeChange.emit($event)">
        </app-single-select-dropdown>
      </div>
      <div class="m-field">
        <label>Vendor Type</label>
        <app-single-select-dropdown
          [options]="vendorTypes"
          [selectedValue]="vendorType"
          (selectedValueChange)="vendorTypeChange.emit($event)">
        </app-single-select-dropdown>
      </div>
    </app-section-card>

    <app-section-card variant="market" icon="bi-shop" title="Target Market &amp; Sales">
      <div class="m-field">
        <label>Target Market</label>
        <app-multi-select-dropdown
          [options]="targetMarkets"
          [selectedValues]="targetMarket"
          (selectedValuesChange)="targetMarketChange.emit($event)">
        </app-multi-select-dropdown>
      </div>
      <div class="m-field">
        <label>Sales Channels</label>
        <app-multi-select-dropdown
          [options]="salesChannels"
          [selectedValues]="salesChannel"
          (selectedValuesChange)="salesChannelChange.emit($event)">
        </app-multi-select-dropdown>
      </div>
    </app-section-card>

    <app-section-card variant="challenges" icon="bi-exclamation-triangle" title="Business Challenges">
      <div class="m-field">
        <label>Describe your key business challenges:</label>
        <textarea class="form-control m-form-control" rows="4"
          [ngModel]="keyChallenges"
          (ngModelChange)="keyChallengesChange.emit($event)"
          placeholder="Describe key business challenges"></textarea>
      </div>
    </app-section-card>

  </div>

  <!-- ===================== SCHEDULE TAB ===================== -->
  <div *ngIf="activeTab === 'schedule'" class="form-stack">


    <app-section-card variant="schedule" icon="bi-calendar-week" title="Regular Weekly Schedule">
      <h6 class="m-section-title">Apply Hours to All Days</h6>
      <div class="row g-2 mb-2">
        <div class="col-6">
          <label class="small text-muted">Open Time</label>
          <input type="time" class="form-control m-form-control"
            [ngModel]="allDaysOpenTime"
            (ngModelChange)="allDaysOpenTimeChange.emit($event)" />
        </div>
        <div class="col-6">
          <label class="small text-muted">Close Time</label>
          <input type="time" class="form-control m-form-control"
            [ngModel]="allDaysCloseTime"
            (ngModelChange)="allDaysCloseTimeChange.emit($event)" />
        </div>
      </div>
      <button class="btn btn-outline-primary btn-sm w-100 mb-2" (click)="applyToAllDays.emit()">
        Apply to All Days
      </button>
      <button class="btn btn-outline-primary btn-sm w-100" (click)="applyAllDays247.emit()">
        <i class="bi bi-clock me-1"></i>Open 24/7
      </button>
    </app-section-card>

    <div class="m-section m-section--day" *ngFor="let day of operatingHours; let i = index">
      <div class="day-header" (click)="toggleDay(i, $event)">
        <i class="bi day-chevron" [ngClass]="expandedDays[i] ? 'bi-chevron-up is-open' : 'bi-chevron-down'"></i>
        <h6 class="day-header-title mb-0">{{ getDayName(day.dayOfWeek) }}</h6>
        <span class="day-summary">{{ formatDayTimes(day) }}</span>
        <button
          type="button"
          class="btn btn-sm ms-2"
          [ngClass]="isDayOpen24Hours(day) ? 'btn-primary' : 'btn-outline-secondary'"
          (click)="$event.stopPropagation(); toggleDay24HoursEvent.emit(i)"
          style="font-size: 0.7rem; padding: 0.15rem 0.45rem;"
        >
          <i class="bi bi-clock me-1"></i>24h
        </button>
        <div class="form-check form-switch mb-0 ms-2">
          <input class="form-check-input" type="checkbox"
            [(ngModel)]="day.isClosed"
            (click)="$event.stopPropagation()" />
        </div>
      </div>
      <ng-container *ngIf="expandedDays[i] && !day.isClosed">
        <div class="row g-2 mt-2">
          <div class="col-6">
            <label class="small text-muted">Open</label>
            <input type="time" class="form-control m-form-control"
              [(ngModel)]="day.openTime" />
          </div>
          <div class="col-6">
            <label class="small text-muted">Close</label>
            <input type="time" class="form-control m-form-control"
              [(ngModel)]="day.closeTime" />
          </div>
        </div>
      </ng-container>
    </div>

    <app-section-card variant="exceptions" icon="bi-calendar-x" title="Special Days &amp; Exceptions">
      <button sectionActions class="btn btn-outline-primary btn-sm" (click)="addException.emit()">+ Add</button>
      <div *ngIf="isFirstLogin && exceptions.length > 0" class="m-holiday-hint">
        <i class="bi bi-info-circle me-1"></i>Pre-filled from public holidays — review and edit before saving.
      </div>
      <div *ngIf="exceptions.length === 0" class="text-muted small text-center py-2">
        No exceptions added yet.
      </div>
      <div class="mdc-card mb-2"
        *ngFor="let ex of exceptions; let i = index">
        <div class="m-field mb-2">
          <label class="small text-muted">Date</label>
          <input type="date" class="form-control m-form-control"
            [(ngModel)]="ex.exceptionDate" />
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="small text-muted mb-0">Closed all day</label>
          <div class="form-check form-switch mb-0">
            <input class="form-check-input me-1" type="checkbox"
              [(ngModel)]="ex.isClosed" />
          </div>
        </div>
        <ng-container *ngIf="!ex.isClosed">
          <div class="row g-2 mb-2">
            <div class="col-6">
              <label class="small text-muted">Open</label>
              <input type="time" class="form-control m-form-control"
                [(ngModel)]="ex.openTime" step="60" />
            </div>
            <div class="col-6">
              <label class="small text-muted">Close</label>
              <input type="time" class="form-control m-form-control"
                [(ngModel)]="ex.closeTime" step="60" />
            </div>
          </div>
        </ng-container>
        <div *ngIf="ex.isClosed" class="text-muted small text-center py-1 mb-2">Closed all day</div>
        <div class="m-field mb-2">
          <label class="small text-muted">Reason (Optional)</label>
          <input type="text" class="form-control m-form-control"
            [(ngModel)]="ex.reason"
            placeholder="e.g. Public Holiday, Maintenance" />
        </div>
        <div class="mdc-actions">
          <button type="button" class="mdc-action-btn mdc-action-btn--delete"
            (click)="requestDelete(i, 'exception')">
            <i class="bi bi-trash"></i> Delete
          </button>
        </div>
      </div>
    </app-section-card>

  </div>

  <!-- ===================== EXPENSES TAB ===================== -->
  <div *ngIf="activeTab === 'expenses'" class="form-stack">

    <app-section-card *ngIf="expensesTab === 'variable'" variant="variable" icon="bi-currency-exchange" title="Variable Costs">
      <button sectionActions class="btn btn-outline-primary btn-sm" (click)="addVariableOverhead.emit()">+ Add</button>
      <div class="m-cfg-toolbar m-cfg-toolbar--inline">
        <div class="m-cfg-search">
          <i class="bi bi-search"></i>
          <input type="text" placeholder="Search variable costs…" [(ngModel)]="searchVariable" />
          <button *ngIf="searchVariable" type="button" class="m-cfg-clear" (click)="searchVariable = ''" aria-label="Clear search">
            <i class="bi bi-x-circle-fill"></i>
          </button>
        </div>
      </div>
    </app-section-card>
    <div *ngIf="expensesTab === 'variable'" class="mobile-cards-area">
      <div *ngIf="variableOverheadItems.length === 0" class="text-muted small text-center py-2">
        No variable costs added.
      </div>
      <div *ngIf="searchVariable && filteredVariableOverheadItems.length === 0" class="m-cfg-empty">
        No variable costs match "{{ searchVariable }}".
      </div>
      <app-mobile-data-card
        *ngFor="let item of filteredVariableOverheadPaged; let i = index"
        [title]="item.overheadName || item.customOverhead || item.overhead || 'Variable Cost'"
        [fields]="variableOverheadFields(item)"
        [animationDelay]="i * 60"
        [fullItem]="item"
        (editTap)="openOffcanvasForVariable($event)"
        (deleteTap)="requestDelete($event, 'variable')">
      </app-mobile-data-card>
      <div *ngIf="filteredVariableOverheadTotalPages > 1" class="inv-pagination">
        <button class="inv-page-btn" [disabled]="variableCurrentPage === 1" (click)="changeVariablePage(variableCurrentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="inv-page-info">{{ variableCurrentPage }} / {{ filteredVariableOverheadTotalPages }}</span>
        <button class="inv-page-btn" [disabled]="variableCurrentPage === filteredVariableOverheadTotalPages" (click)="changeVariablePage(variableCurrentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

    <app-section-card *ngIf="expensesTab === 'fixed'" variant="fixed" icon="bi-currency-exchange" title="Fixed Costs">
      <button sectionActions class="btn btn-outline-primary btn-sm" (click)="addFixedOverhead.emit()">+ Add</button>
      <div class="m-cfg-toolbar m-cfg-toolbar--inline">
        <div class="m-cfg-search">
          <i class="bi bi-search"></i>
          <input type="text" placeholder="Search fixed costs…" [(ngModel)]="searchFixed" />
          <button *ngIf="searchFixed" type="button" class="m-cfg-clear" (click)="searchFixed = ''" aria-label="Clear search">
            <i class="bi bi-x-circle-fill"></i>
          </button>
        </div>
      </div>
    </app-section-card>
    <div *ngIf="expensesTab === 'fixed'" class="mobile-cards-area">
      <div *ngIf="fixedOverheadItems.length === 0" class="text-muted small text-center py-2">
        No fixed costs added.
      </div>
      <div *ngIf="searchFixed && filteredFixedOverheadItems.length === 0" class="m-cfg-empty">
        No fixed costs match "{{ searchFixed }}".
      </div>
      <app-mobile-data-card
        *ngFor="let item of filteredFixedOverheadPaged; let i = index"
        [title]="item.customOverhead || item.overhead || 'Fixed Cost'"
        [fields]="fixedOverheadFields(item)"
        [animationDelay]="i * 60"
        [fullItem]="item"
        (editTap)="openOffcanvasForFixed($event)"
        (deleteTap)="requestDelete($event, 'fixed')">
      </app-mobile-data-card>
      <div *ngIf="filteredFixedOverheadTotalPages > 1" class="inv-pagination">
        <button class="inv-page-btn" [disabled]="fixedCurrentPage === 1" (click)="changeFixedPage(fixedCurrentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="inv-page-info">{{ fixedCurrentPage }} / {{ filteredFixedOverheadTotalPages }}</span>
        <button class="inv-page-btn" [disabled]="fixedCurrentPage === filteredFixedOverheadTotalPages" (click)="changeFixedPage(fixedCurrentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

  </div>

  <!-- ===================== SALARIES TAB ===================== -->
  <div *ngIf="activeTab === 'salaries'" class="form-stack">

    <app-section-card variant="salaries" icon="bi-cash-coin" title="Salary Records">
      <button sectionActions class="btn btn-outline-primary btn-sm" (click)="addSalary.emit()">+ Add</button>
      <div class="m-cfg-toolbar m-cfg-toolbar--inline">
        <div class="m-cfg-search">
          <i class="bi bi-search"></i>
          <input type="text" placeholder="Search salaries…" [(ngModel)]="searchSalaries" />
          <button *ngIf="searchSalaries" type="button" class="m-cfg-clear" (click)="searchSalaries = ''" aria-label="Clear search">
            <i class="bi bi-x-circle-fill"></i>
          </button>
        </div>
      </div>
    </app-section-card>
    <div class="mobile-cards-area">
      <div *ngIf="employeeSalaries.length === 0" class="text-muted small text-center py-2">
        No salaries added.
      </div>
      <div *ngIf="searchSalaries && filteredSalaries.length === 0" class="m-cfg-empty">
        No salaries match "{{ searchSalaries }}".
      </div>
      <app-mobile-data-card
        *ngFor="let sal of filteredSalariesPaged; let i = index"
        [title]="getEmployeeName(sal.employeeID)"
        [fields]="salaryFields(sal)"
        [animationDelay]="i * 60"
        [fullItem]="sal"
        (editTap)="openOffcanvasForSalary($event)"
        (deleteTap)="requestDelete($event, 'salary')">
      </app-mobile-data-card>
      <div *ngIf="filteredSalariesTotalPages > 1" class="inv-pagination">
        <button class="inv-page-btn" [disabled]="salariesCurrentPage === 1" (click)="changeSalariesPage(salariesCurrentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="inv-page-info">{{ salariesCurrentPage }} / {{ filteredSalariesTotalPages }}</span>
        <button class="inv-page-btn" [disabled]="salariesCurrentPage === filteredSalariesTotalPages" (click)="changeSalariesPage(salariesCurrentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

  </div>

  <!-- ===================== EMPLOYEES TAB ===================== -->
  <div *ngIf="activeTab === 'employees'" class="form-stack">

    <app-section-card variant="employees" icon="bi-people" title="Employee List">
      <button sectionActions class="btn btn-outline-primary btn-sm" (click)="addEmployee.emit()">+ Add</button>
      <div class="m-cfg-toolbar m-cfg-toolbar--inline">
        <div class="m-cfg-search">
          <i class="bi bi-search"></i>
          <input type="text" placeholder="Search employees…" [(ngModel)]="searchEmployees" />
          <button *ngIf="searchEmployees" type="button" class="m-cfg-clear" (click)="searchEmployees = ''" aria-label="Clear search">
            <i class="bi bi-x-circle-fill"></i>
          </button>
        </div>
      </div>
    </app-section-card>
    <div class="mobile-cards-area">
      <div *ngIf="employees.length === 0" class="text-muted small text-center py-2">
        No employees added yet.
      </div>
      <div *ngIf="searchEmployees && filteredEmployees.length === 0" class="m-cfg-empty">
        No employees match "{{ searchEmployees }}".
      </div>
      <app-mobile-data-card
        *ngFor="let emp of filteredEmployeesPaged; let i = index"
        [title]="emp.firstName + ' ' + emp.lastName"
        [fields]="employeeFields(emp)"
        [animationDelay]="i * 60"
        [fullItem]="emp"
        (editTap)="openOffcanvasForEmployee($event)"
        (deleteTap)="requestDelete($event, 'employee')">
      </app-mobile-data-card>
      <div *ngIf="filteredEmployeesTotalPages > 1" class="inv-pagination">
        <button class="inv-page-btn" [disabled]="employeesCurrentPage === 1" (click)="changeEmployeesPage(employeesCurrentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="inv-page-info">{{ employeesCurrentPage }} / {{ filteredEmployeesTotalPages }}</span>
        <button class="inv-page-btn" [disabled]="employeesCurrentPage === filteredEmployeesTotalPages" (click)="changeEmployeesPage(employeesCurrentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

  </div>

  <!-- Progress strip — fixed band above the action bar (outside action bar so expenses bottom nav doesn't obscure it) -->
  <div *ngIf="isFirstLogin"
       class="m-setup-progress-fixed"
       [class.m-setup-progress-fixed--with-nav]="activeTab === 'expenses'">
    <div class="m-setup-progress-bar">
      <div class="m-setup-progress-fill" [style.width.%]="((currentTabIndex + 1) / setupTabs.length) * 100"></div>
    </div>
    <span class="m-setup-progress-label">{{ progressLabel }}</span>
  </div>

  <!-- ===================== FLOATING ACTION BAR ===================== -->
  <div class="m-action-bar"
    *ngIf="!(activeTab === 'expenses' && !isFirstLogin)"
    [class.m-action-bar--with-nav]="activeTab === 'expenses'">
    <button *ngIf="activeTab === 'details' || activeTab === 'schedule' || (isFirstLogin && activeTab === 'expenses') || (isFirstLogin && activeTab === 'salaries')"
      class="btn btn-primary w-100"
      (click)="saveAndContinue()">
      {{ saveButtonLabel }}
    </button>
    <button *ngIf="activeTab === 'employees' && !isFirstLogin"
      class="btn btn-primary w-100"
      (click)="addEmployee.emit()">
      + Add Employee
    </button>
    <button *ngIf="activeTab === 'employees' && isFirstLogin"
      class="btn btn-primary w-100"
      (click)="saveAndContinue()">
      {{ saveButtonLabel }}
    </button>
    <button *ngIf="activeTab === 'salaries' && !isFirstLogin"
      class="btn btn-primary w-100"
      (click)="addSalary.emit()">
      + Add Salary
    </button>
  </div>

</app-mobile-page-shell>

<!-- Offcanvas for add/edit (rendered outside page shell so position:fixed works correctly) -->
<app-business-item-offcanvas
  [visible]="offcanvasVisible"
  [mode]="offcanvasMode"
  [item]="offcanvasItem"
  [employees]="employees"
  [roles]="roles"
  [periodTypes]="periodTypes"
  [variableOverheads]="variableOverheads"
  [fixedOverheads]="fixedOverheads"
  [unitsOfMeasure]="unitsOfMeasure"
  (save)="onOffcanvasSave($event)"
  (closeCanvas)="onOffcanvasCancel()">
</app-business-item-offcanvas>

<!-- Welcome onboarding modal — shown on first login until dismissed -->
<div class="modal-overlay" *ngIf="isFirstLogin && !welcomeDismissed" (click)="$event.stopPropagation()">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Welcome to Aivor!</h5>
    </div>
    <div class="modal-body">
      <p class="confirmation-text">Let's set up your business. Tap <strong>Next</strong> on each tab to progress through <strong>Details</strong>, <strong>Schedule</strong>, <strong>Expenses</strong>, <strong>Employees</strong>, and <strong>Salaries</strong>. You'll get access to the rest of the app once setup is complete.</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-save" (click)="welcomeDismissed = true">Got it</button>
    </div>
  </div>
</div>

<!-- Setup complete modal -->
<div class="modal-overlay" [class.active]="showSetupCompleteModal" *ngIf="showSetupCompleteModal" (click)="$event.stopPropagation()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h5 class="modal-title">You're all set!</h5>
    </div>
    <div class="modal-body">
      <p class="confirmation-text">Your business profile is saved. You can now use the menu (☰) at the top to explore the rest of the app, or stay here to add more details.</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-save" (click)="showSetupCompleteModal = false">Got it</button>
    </div>
  </div>
</div>

<!-- Delete confirm modal -->
<div class="m-del-overlay" [class.active]="showDeleteConfirm" *ngIf="showDeleteConfirm" (click)="cancelDelete()">
  <div class="m-del-sheet" (click)="$event.stopPropagation()">
    <div class="m-del-handle-bar"><div class="m-del-handle"></div></div>
    <div class="m-del-header">
      <h5 class="m-del-title">Confirm Deletion</h5>
      <button class="m-del-close-btn" (click)="cancelDelete()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="m-del-body">
      <p class="m-del-text">Are you sure you want to remove this entry? This will
        <strong class="text-danger">delete the record</strong> from the database.</p>
    </div>
    <div class="m-del-footer">
      <button class="btn m-del-btn-cancel flex-fill" (click)="cancelDelete()">Cancel</button>
      <button class="btn m-del-btn-confirm flex-fill" (click)="confirmDelete()">Confirm</button>
    </div>
  </div>
</div>
